import React, { useState, useEffect } from 'react';

import { Footer, Blog, Possibility, Features, WhatSam, Header } from './containers';
import { CTA, Brand, Navbar, Loading } from './components';

import './App.css';

const App = () => {
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1600);
  }, []);

  return (
    <div className="App">
      {loading ? (
        < Loading />
      ) : (
        <div>
          <div className="gradient__bg">
            <Navbar />
            <Header />
          </div>
          <Brand />
          <WhatSam />
          <Features />
          <Possibility />
          <CTA />
          <Blog />
          <Footer />
        </div>
      )
      }

    </div >
  )
};


// return (
//   <div className="App">
//     <div className="gradient__bg">
//       <Navbar />
//       <Header />
//     </div>
//     <Brand />
//     <WhatSam />
//     <Features />
//     <Possibility />
//     <CTA />
//     <Blog />
//     <Footer />
//   </div>
// )

export default App;
